module.exports = __webpack_public_path__ + "img/vape-shop-custom-website.bc758b94.jpg";